const translation = {
    PageSize: 'Papierformat',
    PageOrientation: 'Papierausrichtung',
    Format: 'Dateiformat',
    DPI: 'Druckauflösung',
    Title: 'Karte exportieren',
    Close: 'Schließen',
    Save: 'Speichern',
    FileName: 'Dateiname',
    Landscape: 'Querformat',
    Portrait: 'Hochformat',
    PreviewHint: 'Den Exportbereich auf der Karte oder mit den Schaltflächen und Pfeiltasten anpassen.',
    ExportFailed: 'Der Export der Karte ist fehlgeschlagen. Bitte erneut versuchen.',
    PreviewFailed: 'Die Vorschau konnte nicht erstellt werden.',
    AdjustArea: 'Bereich auf der Karte anpassen',
    AdjustAreaHint: 'Karte verschieben, zoomen, drehen oder neigen, um den Exportbereich festzulegen',
    ZoomIn: 'Vergrößern',
    ZoomOut: 'Verkleinern',
    ResetZoom: 'Zoom auf 100 % zurücksetzen',
    Done: 'Fertig',
    Cancel: 'Abbrechen',
    Scalebar: 'Maßstabsleiste',
    NorthIcon: 'Nordpfeil',
    ChooseNorthIcon: 'Nordpfeil auswählen',
    ChooseSvgFile: 'SVG-Datei auswählen',
    IconSymbol: 'Symbol',
    IconColor: 'Farbe',
    IconSize: 'Größe',
    InvalidSvg: 'Die Datei ist kein gültiges SVG.',
    ExportAsVector: 'Als Vektor exportieren',
    ExportLabelsAsVector: 'Beschriftungen als Vektor exportieren',
    Custom: 'Benutzerdefiniert',
    Width: 'Breite',
    Height: 'Höhe',
    LanguageName: 'Deutsch',
    LanguageCode: 'de'
};
export default translation;
